import script from "./UserList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserList.vue?vue&type=script&setup=true&lang=ts"

import "./UserList.vue?vue&type=style&index=0&id=ffbc13fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffbc13fe"]])

export default __exports__